// @flow

import * as React from 'react';
import classnames from 'classnames';
import useOnClickOutside from 'hooks/useOnClickOutside';
import Link from 'components/Link';
import Icon from 'components/Icon';
import NavItem from '../Item';

import type { IconType } from 'components/Icon';
import type { NavLink } from '..';

type Props = {|
    title: React.Node,
    items: NavLink[],
    icon?: IconType
|};

const HeaderNavDropdown = ({ title, items, icon }: Props): React.Node => {
    const [open, setOpen] = React.useState<boolean>(false);

    const ref = React.useRef();
    useOnClickOutside(ref, () => { setOpen(false); });

    const handleToggle = React.useCallback(() => {
        setOpen(prevState => !prevState);
    }, []);

    const handleItemClick = React.useCallback(
        (item: NavLink) => (e: SyntheticMouseEvent<*>) => {
            setOpen(false);

            if (item.onClick) {
                item.onClick(e);
            }
        },
        []
    );

    const liClassName = classnames('HeaderNavDropdown', {
        'HeaderNavDropdown--open'            : open,
        'HeaderNavDropdown--no-icon'         : icon === undefined,
        [`HeaderNavDropdown--${icon || ''}`] : !!icon
    });

    return (
        <li ref={ref} className={liClassName}>
            <Link icon={icon} onClick={handleToggle}>
                <span className="HeaderNavDropdown__title">{title}</span>
                <Icon className="HeaderNavDropdown__carret" type="carret" />
            </Link>
            <ul className="HeaderNavDropdown__dropdown">
                {items.map((item: NavLink, index: number) => (
                    <NavItem
                        icon={item.icon}
                        key={item.key || index}
                        title={item.title}
                        url={item.url}
                        onClick={handleItemClick(item)}
                    />
                ))}
            </ul>
        </li>
    );
};

export default HeaderNavDropdown;
